/* Totkind — uoc tinh ngay giao (blocks/tk-delivery.liquid). Khong phu thuoc thu vien. */
(function () {
  'use strict';
  var THANG = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* "US:3-6, CA:6-12, *:8-15" -> { US:[3,6], CA:[6,12], '*':[8,15] } (giu thu tu) */
  function docVung(s) {
    var ra = { _thuTu: [] };
    String(s || '').split(',').forEach(function (x) {
      var m = /^\s*([A-Za-z*]{1,2})\s*:\s*(\d+)\s*-\s*(\d+)\s*$/.exec(x);
      if (!m) return;
      var k = m[1].toUpperCase();
      ra[k] = [+m[2], Math.max(+m[2], +m[3])];
      ra._thuTu.push(k);
    });
    return ra;
  }
  /* ngay hom nay + gio hien tai theo mui gio cua hang (chot don tinh theo gio xuong lam viec) */
  function homNay(tz) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var g = {}; p.forEach(function (x) { g[x.type] = x.value; });
      return { d: new Date(+g.year, +g.month - 1, +g.day), h: +g.hour };
    } catch (e) { var n = new Date(); return { d: new Date(n.getFullYear(), n.getMonth(), n.getDate()), h: n.getHours() }; }
  }
  function khoa(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function ngayLam(d, le) { var t = d.getDay(); return t !== 0 && t !== 6 && !le[khoa(d)]; }
  /* cong n ngay lam viec (n = 0 -> chinh ngay do neu la ngay lam, khong thi ngay lam ke tiep) */
  function congLam(d, n, le) {
    var x = new Date(d.getTime());
    while (!ngayLam(x, le)) x.setDate(x.getDate() + 1);
    for (var i = 0; i < n; i++) { do { x.setDate(x.getDate() + 1); } while (!ngayLam(x, le)); }
    return x;
  }
  function ngan(d) { return THANG[d.getMonth()] + ' ' + ('0' + d.getDate()).slice(-2); }
  function khoang(a, b) {
    if (a.getTime() === b.getTime()) return THANG[a.getMonth()] + ' ' + a.getDate();
    if (a.getMonth() === b.getMonth()) return THANG[a.getMonth()] + ' ' + a.getDate() + ' – ' + b.getDate();
    return THANG[a.getMonth()] + ' ' + a.getDate() + ' – ' + THANG[b.getMonth()] + ' ' + b.getDate();
  }
  function dung(goc) {
    if (goc.__tk) return; goc.__tk = 1;
    var ds = goc.dataset;
    var vung = docVung(ds.vung);
    var sx = (ds.sx || '1-3').split('-').map(Number);
    var le = {}; String(ds.le || '').split(/[\s,]+/).forEach(function (x) { if (/^\d{4}-\d{2}-\d{2}$/.test(x)) le[x] = 1; });
    var nutNgay = goc.querySelector('[data-tk-gh-mo]'), hop = goc.querySelector('[data-tk-gh-hop]');
    var vungUt = docVung(ds.vungUt || '');
    var nhan = goc.querySelector('[data-tk-gh-nhan]'), nhanChu = goc.querySelector('[data-tk-gh-nhan-chu]');

    /* chi ban My (05/10): luon tinh theo US, khong cho khach chon nuoc */
    var tinhVung = function (ma) { return vung[ma] ? ma : (vung['*'] ? '*' : vung._thuTu[0]); };

    function ve(ma) {
      var k = tinhVung(ma);
      var h = homNay(ds.tz || 'America/Los_Angeles');
      var batDau = new Date(h.d.getTime());
      if (!ngayLam(batDau, le) || h.h >= Number(ds.chot || 12)) batDau = congLam(batDau, 1, le);
      var giao = vung[k] || [5, 10];
      var s1 = congLam(batDau, sx[0], le), s2 = congLam(batDau, sx[1] || sx[0], le);
      var g1 = congLam(s1, giao[0], le), g2 = congLam(s2, giao[1], le);
      goc.querySelectorAll('[data-tk-gh-mo]').forEach(function (n) {
        if (n.getAttribute('data-tk-gh-loai') === 'ut') {                 /* Priority: cung ngay san xuat, van chuyen nhanh hon */
          var gu = vungUt[k] || vungUt['*'] || vungUt[vungUt._thuTu && vungUt._thuTu[0]] || [1, 2];
          n.textContent = khoang(congLam(s1, gu[0], le), congLam(s2, gu[1], le));
        } else n.textContent = khoang(g1, g2);
      });
      goc.querySelectorAll('[data-tk-gh-d1]').forEach(function (e) { e.textContent = ngan(h.d); });
      goc.querySelectorAll('[data-tk-gh-d2]').forEach(function (e) { e.textContent = khoang(s1, s2).replace(' – ', '–'); });
      goc.querySelectorAll('[data-tk-gh-d3]').forEach(function (e) { e.textContent = khoang(g1, g2); });
      /* dong nhan: mua Noel (1/11 -> 24/12) va KIP giao truoc 24/12 thi doi cau */
      var cau = '';
      var noel = new Date(h.d.getFullYear(), 11, 24), dauMua = new Date(h.d.getFullYear(), 10, 1);
      if (ds.noel === 'true' && h.d >= dauMua && h.d <= noel && g2 <= noel) cau = ds.noelChu || '';
      if (!nhanChu) return;
      if (!cau) cau = nhanChu.getAttribute('data-mac-dinh') || '';
      cau = cau.replace(/<\/?p>/g, '');
      nhanChu.innerHTML = cau;
      nhan.hidden = !cau;
    }

    ve('US');

    if (!nutNgay || !hop) return;     /* kieu inline: khong co nut / hop */
    goc.querySelectorAll('[data-tk-gh-mo]').forEach(function (n) { n.addEventListener('click', function () { if (hop.showModal) hop.showModal(); else hop.setAttribute('open', ''); }); });
    goc.querySelector('[data-tk-gh-dong]').addEventListener('click', function () { hop.close ? hop.close() : hop.removeAttribute('open'); });
    hop.addEventListener('click', function (e) { if (e.target === hop && hop.close) hop.close(); });   /* bam nen mo de dong */
  }

  function chay() { document.querySelectorAll('[data-tk-gh]').forEach(dung); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chay); else chay();
  document.addEventListener('shopify:block:select', chay);
  document.addEventListener('shopify:section:load', chay);
})();
